import type { TimeValue } from "../TimePicker/types";

export const DEFAULT_DATE_FORMAT = "dd/MM/yyyy";
export const DEFAULT_TIME_FORMAT = "HH:mm:ss";

export const INITIAL_TIME_VALUE: TimeValue = {
  hours: 0,
  minutes: 0,
  seconds: 0,
};

export const SIZE_CONFIG = {
  small: {
    trigger: "h-8 md:h-7",
    input: "text-base md:text-xs",
    icon: "size-3.5",
  },
  medium: {
    trigger: "h-8",
    input: "text-base md:text-sm",
    icon: "size-4",
  },
  large: {
    trigger: "h-10",
    input: "text-base md:text-sm",
    icon: "size-5",
  },
} as const;
